import { EXPERIMENT_ID_NOT_SET } from 'root-constants/common'

export const getCurrentExperimentId = (experimentId: string): string =>
  experimentId || EXPERIMENT_ID_NOT_SET
